/**
 * altenotPos.ts — Puente Capacitor hacia hardware POS (impresora térmica, gaveta).
 */

import { registerPlugin } from "@capacitor/core";

export interface OpenCashDrawerOptions {
  reason?: string;
}

export interface PosPrinterConfigPayload {
  transport: string;
  address: string;
  deviceName: string;
  networkHost: string;
  networkPort: number;
  bluetoothMac: string;
  usbDeviceKey?: string;
  paperWidthMm: number;
  brand: string;
}

export interface BluetoothPrinterDevice {
  name: string;
  address: string;
}

export interface UsbPrinterDevice {
  name: string;
  vendorId: number;
  productId: number;
  deviceKey: string;
  hasPermission?: boolean;
}

export interface UsbPermissionResult {
  granted: boolean;
}

export interface AltenotPosPlugin {
  openCashDrawer(options?: OpenCashDrawerOptions): Promise<void>;
  getPrinterConfig(): Promise<PosPrinterConfigPayload | null>;
  setPrinterConfig(options: Partial<PosPrinterConfigPayload>): Promise<void>;
  listPairedBluetoothPrinters(): Promise<{ devices: BluetoothPrinterDevice[] }>;
  listUsbPrinters(): Promise<{ devices: UsbPrinterDevice[] }>;
  /** Muestra el diálogo nativo de Android para conceder acceso USB OTG. */
  requestUsbPermission(options?: {
    deviceKey?: string;
  }): Promise<UsbPermissionResult>;
  printTestPage(): Promise<void>;
  /** Buffer ESC/POS en Base64 (sin UI; solo bytes del ticket). */
  printEscPosBase64(options: { dataBase64: string }): Promise<void>;
}

export const AltenotPos = registerPlugin<AltenotPosPlugin>("AltenotPos", {
  web: () => ({
    openCashDrawer: async () => undefined,
    getPrinterConfig: async () => null,
    setPrinterConfig: async () => undefined,
    listPairedBluetoothPrinters: async () => ({ devices: [] }),
    listUsbPrinters: async () => ({ devices: [] }),
    requestUsbPermission: async () => ({ granted: true }),
    printTestPage: async () => undefined,
    printEscPosBase64: async () => undefined,
  }),
});
